import React from 'react'
import './contact.css'

const Contact = () => {
  return (
    <div>Contact</div>
  )
}

export default Contact